import { Link } from "react-router-dom";
import queryString from "query-string";
import { connect } from "react-redux";
import { useEffect } from "react";
import { HOME } from "../../router/routes";
import getCompanyFromDomain from "../../services/Company";
import { saveTokenInLocalStorageAndFillState } from "../../redux/auth/action";
import {
  CognitoIdToken,
  CognitoAccessToken,
  CognitoRefreshToken,
  CognitoUserSession,
  CognitoUser,
} from "amazon-cognito-identity-js";
import UserPool from "src/auth/UserPool";

function AuthVerify(props) {
  useEffect(() => {
    const authToken = queryString.parse(props.location.search);
    const company = getCompanyFromDomain();
    const cognitoUser = new CognitoUser({
      Username: authToken.email,
      Pool: UserPool,
    });

    // 2) wrap your raw tokens in the SDK classes
    const idToken = new CognitoIdToken({
      IdToken: authToken.ctoken,
    });
    const accessToken = new CognitoAccessToken({
      AccessToken: authToken.atoken,
    });
    const refreshToken = new CognitoRefreshToken({
      RefreshToken: authToken.rtoken,
    });

    // 4️⃣ Create a session and store it
    const cognitoUserSession = new CognitoUserSession({
      IdToken: idToken,
      AccessToken: accessToken,
      RefreshToken: refreshToken,
    });
    cognitoUser.setSignInUserSession(cognitoUserSession);
    props.pullUserInformation(authToken.atoken || "", authToken.rtoken || "", company.id, HOME);
  }, []);
  return <></>;
}
const mapDispatchToProps = (dispatch) => ({
  pullUserInformation: (accessToken, refreshToken, companyId, path) =>
    dispatch(saveTokenInLocalStorageAndFillState(accessToken, refreshToken, companyId, path)),
});
const mapStateToProps = () => {};
export default connect(mapStateToProps, mapDispatchToProps)(AuthVerify);
